import { OperationVariables, QueryTuple } from '@apollo/client';
import { getApolloLink, useApolloLazyQuery, useCookie } from '@netfront/common-library';

import { IUseKanziLazyQueryInputVariables } from './useKanziLazyQuery.interfaces';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useKanziLazyQuery = <TData = any, TVariables extends OperationVariables = OperationVariables>({
  apolloLink,
  options,
  query,
  token,
}: IUseKanziLazyQueryInputVariables<TData, TVariables>): QueryTuple<TData, TVariables> => {
  const { getAccessTokenCookie, getTemporaryTokenCookie } = useCookie();

  const accessToken = getAccessTokenCookie();
  const temporaryToken = getTemporaryTokenCookie();

  const authenticationLink = getApolloLink({
    apiName: 'kanzi',
    token: token ?? accessToken ?? temporaryToken,
  });

  return useApolloLazyQuery({
    apiName: 'kanzi',
    apolloLink: apolloLink ?? authenticationLink,
    options,
    query,
  });
};

export { useKanziLazyQuery };
